import { makeStyles } from '@mui/styles';
const miscOffersStyles = makeStyles(({ palette: { common: { black }, }, }) => ({
    title: {
        color: black,
        fontWeight: 700,
    },
    totalPrice: {
        fontWeight: 700,
    },
    content: {
        width: '100%',
    },
    rightText: {},
}), { name: 'Common_MiscOffers' });
export default miscOffersStyles;
//# sourceMappingURL=miscOffers.styles.js.map